import { hasProperty } from './has-property';

export function getValue<T extends object>(object: T, key: string): T[keyof T] {
    if (!hasProperty(object, key)) {
        throw new Error(`Object has no property ${key}`);
    }
    return object[key as keyof T];
}
